import { MovieGridWithTabs, MovieTabProps } from "@picovico/ui";
import { convertMinutesToHours, getLocalStorageData } from "@picovico/utils";
import {
  useGetNextReleaseQuery,
  useLazyGetComingSoonQuery,
} from "@store/services/movie";

import { getPageRoutes } from "@pageRoutes";
import { differenceInDays, format } from "date-fns";
import { useAppSelector } from "store";

function NextReleaseUpcoming(props: Omit<MovieTabProps, "tabs">) {
  const { company_idx } = useAppSelector((state) => state.config);
  const { cinema_hall } = useAppSelector((state) => state.activeCinemaHall);

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const {
    isFetching,
    isLoading,
    data: nextRelease,
  } = useGetNextReleaseQuery(
    { company_idx, cinema_hall },
    {
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
      refetchOnFocus: true,
    },
  );
  const [getComingSoon, { isLoading: isLoadingComingSoon, data: comingSoon }] =
    useLazyGetComingSoonQuery({
      refetchOnReconnect: true,
      refetchOnFocus: true,
    });

  return (
    <MovieGridWithTabs
      {...props}
      tabs={[
        {
          title: "Next Release",
          movies: nextRelease?.data?.map(
            ({
              idx,
              name,
              release_date,
              grade,
              genre,
              tag,
              poster,
              duration,
              trailer,
              movieinfo,
              roll_quality,
              has_show,
            }) => {
              const releaseDateObj = new Date(release_date);
              const daysLeft = differenceInDays(releaseDateObj, today);

              let ribbonText: string | undefined;
              if (daysLeft > 0) {
                ribbonText = `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`;
              } else if (daysLeft === 0) {
                ribbonText = "Releasing Today";
              }

              return {
                idx,
                title: name,
                grade,
                genre,
                tag,
                roll_quality,
                poster,
                detailLink: getPageRoutes(
                  "movie_detail",
                  {
                    movieIdx: idx,
                    cinemaHallIdx:
                      cinema_hall ?? getLocalStorageData("cinema_hall"),
                  },
                  {
                    startDate: movieinfo?.show_start_date
                      ? format(movieinfo?.show_start_date, "yyyy-MM-dd")
                      : "",
                    // endDate: movieinfo.show_end_date,
                  },
                ),
                duration: convertMinutesToHours(duration),
                releaseDate: format(releaseDateObj, "MMMM d yyyy"),
                videoLink: trailer,
                isNowShowing: has_show,
                ribbonText,
              };
            },
          ),
          isLoading: isLoading || isFetching,
        },
        {
          title: "Coming Soon",
          isLoading: isLoadingComingSoon,
          movies:
            comingSoon?.data?.map(
              ({
                idx,
                name,
                release_date,
                grade,
                genre,
                tag,
                poster,
                duration,
                trailer,
                has_show,
              }) => {
                const releaseDateObj = new Date(release_date);
                const daysLeft = differenceInDays(releaseDateObj, today);

                let ribbonText: string | undefined;
                if (daysLeft > 0) {
                  ribbonText = `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`;
                } else if (daysLeft === 0) {
                  ribbonText = "Releasing Today";
                }

                return {
                  idx,
                  title: name,
                  grade,
                  genre,
                  tag,
                  poster,
                  detailLink: getPageRoutes("movie_detail", {
                    movieIdx: idx,
                    cinemaHallIdx: getLocalStorageData("cinema_hall"),
                  }),
                  duration: convertMinutesToHours(duration),
                  releaseDate: format(releaseDateObj, "MMMM d yyyy"),
                  videoLink: trailer,
                  isNowShowing: has_show,
                  ribbonText,
                };
              },
            ) || [],
          onTabChange: () => {
            getComingSoon(
              {
                company_idx,
                cinema_hall: cinema_hall ?? getLocalStorageData("cinema_hall"),
              },
              true,
            );
          },
        },
      ]}
    />
  );
}

export default NextReleaseUpcoming;
